module.exports = __webpack_public_path__ + "media/images/stanford_on_broadway/SimoneDeco-cb31572a66b4efeedf9fba010e0a8b9f.png";